import { useTranslation } from "react-i18next"

import type { ButtonProps } from "@/components/ui/button"

import { MessageCircleQuestion } from "@/components/icons"
import { buttonVariants } from "@/components/ui/button-variants"
import { cn } from "@/lib/utils"

type CourseFeedbackButtonProps = ButtonProps & {
  showText?: boolean
}

export function CourseFeedbackButton({
  className,
  variant,
  size,
  showText = true,
}: CourseFeedbackButtonProps) {
  const { t } = useTranslation("", { keyPrefix: "training.interface.buttons" })

  return (
    <a
      href="https://forms.office.com/pages/responsepage.aspx?id=aNAajMz86kaVD95SuCBnSaILmEwg8iVNk8mWimQqcBlUNVJJSFhNUFlGOUdMTENBQTA2WEpaNVowMy4u&route=shorturl"
      rel="noreferrer"
      target="_blank"
      className={cn(
        buttonVariants({
          variant: variant ?? "icon",
          size: size ?? "default",
          className: "flex w-fit items-center gap-1 px-3 text-lg",
        }),
        className,
        {
          "w-full justify-center px-0 py-0": !showText,
        }
      )}
    >
      <MessageCircleQuestion className="size-5 shrink-0" />
      {showText && t("feedback")}
    </a>
  )
}
